// extracted by mini-css-extract-plugin
module.exports = {"setcionTitle":"index-setcionTitle-YhwSn","safe":"index-safe-1qFgd"};